<template>
  <div class="main-css myBox">
    <div class="main-box">
      <!--    标题-->
      <div class="title-css">{{ $t("allCandidates") }}</div>
      <!-- table部分 -->
      <div class="table">
        <el-table
          @row-click="returns"
          :data="tableData"
          :maxHeight="tableHeight"
          @sort-change="changeTableSort"
          v-loading="loading"
        >
          <el-table-column type="selection"></el-table-column>
          <!-- ----------------------人材番号---------------------- -->
          <el-table-column
            prop="institutionNumber"
            label="人材番号"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("talentNumber") }}</p>
              <el-input
                @change="fuzzy"
                v-model="searchData1"
                size="mini"
                placeholder="Search"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.resumeId }}
            </template>
          </el-table-column>
          <!-- ----------------------氏名---------------------- -->
          <el-table-column prop="Name"   min-width="110"
              :show-overflow-tooltip="true" label="氏名">
            <template
              slot="header"
              slot-scope="scope"
            >
              <p>{{ $t("name") }}</p>
              <el-input
                @change="fuzzy"
                v-model="searchData2"
                size="mini"
                placeholder="Search"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <!-- ----------------------応募案件---------------------- -->
          <el-table-column
            prop="RecruitmentName"
            label="応募案件"
            width="140"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("caseName") }}</p>
              <el-input
                @change="fuzzy"
                v-model="searchData3"
                size="mini"
                placeholder="Search"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.jobName }}
            </template>
          </el-table-column>
          <!-- ------------------------性别------------------------ -->
          <el-table-column prop="sex" label="性别">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("sex") }}</p>
              <el-dropdown @command="handleCommandSex">
                <span class="el-dropdown-link">
                  {{ opSex }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in sexValue"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                  <el-dropdown-item :command="null">
                    {{ "ALL" }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.sex_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpsex_dictText }}
              </span>
            </template>
          </el-table-column>

          <!-- ----------------------生年月日---------------------- -->
          <el-table-column prop="birthday" label="生年月日" width="110">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("birth") }}</p>
              <el-date-picker
                v-model="searchData4"
                type="date"
                @blur="dataTimeChange"
                @change="pickerChangeFn"
                format="yyyy-MM-dd"
                clearable
                :placeholder="$t('registerDayselsect')"
              >
              </el-date-picker>
            </template>
            <template slot-scope="scope">
              {{ scope.row.birth.split(" ")[0] }}
            </template>
          </el-table-column>
          <!-- ----------------------学歴---------------------- -->
          <el-table-column
            prop="educationaBackground"
            label="学歴"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("education") }}</p>
              <el-input
                @change="fuzzy"
                v-model="searchData5"
                size="mini"
                placeholder="Search"
              />
            </template>
            <template slot-scope="scope">
              {{
                language === "CN"
                  ? scope.row.education_dictText
                  : scope.row.jpeducation_dictText
              }}
            </template>
          </el-table-column>
          <!-- ---------------------専攻--------------------- -->
          <el-table-column
            prop="specialize"
            label="専攻"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("major") }}</p>
              <el-input
                @change="fuzzy"
                v-model="searchData6"
                size="mini"
                placeholder="Search"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.profession }}
            </template>
          </el-table-column>
          <!-- -----------------------日本語----------------------- -->
          <el-table-column
            prop="Japaneselevel"
            label="日本語"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("japanese") }}</p>
              <el-input
                @change="fuzzy"
                v-model="searchData7"
                size="mini"
                placeholder="Search"
              />
            </template>
            <template slot-scope="scope">
              {{
                language === "CN"
                  ? scope.row.japanese_dictText
                  : scope.row.jpjapanese_dictText
              }}
            </template>
          </el-table-column>
          <!-- ------------------------応募日------------------------ -->
          <el-table-column
            prop="recruitmentDate"
            label="応募日"
            min-width="120"
            :sortable="'custom'"
          >
            <template slot="header">
              <p class="operate">{{ $t("applicationDate") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.createTime.split(" ")[0] }}
            </template>
          </el-table-column>
          <!-- --------------------------操作-------------------------- -->
          <el-table-column prop="state" label="状态" min-width="90">
            <!-- <template slot="header">
              <p>{{ $t("status") }}</p>
              <el-input v-model="searchData8" size="mini" placeholder="Search" />
            </template> -->
            <template slot="header" slot-scope="scope">
              <p>{{ $t("status") }}</p>
              <el-dropdown @command="handleCommandStatus">
                <span class="el-dropdown-link">
                  {{ opStatus
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in sexStatus"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                  <el-dropdown-item :command="null">
                    {{ "ALL" }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <div v-for="item in List">
                <span v-if="item.code == scope.row.applyStatus">{{
                  item.name
                }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页部分 -->
        <div class="pagination">
          <div class="pagination-main">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              layout=" prev, pager, next"
              :total="total"
              :page-size="pageSize"
            >
            </el-pagination>
            <!-- Rows per page -->
            <div class="rowsPage">
              <span>Rows per page</span>
              <div class="rowsPage-css">
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{ this.pageSize
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a">10</el-dropdown-item>
                    <el-dropdown-item command="b">15</el-dropdown-item>
                    <el-dropdown-item command="c">20</el-dropdown-item>
                    <el-dropdown-item command="d">25</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  medicalFindAllApplyPerson,
  medicalFuzzyFindAllApplyPerson,
  getDateItem
} from "../../js/api";
import AES from "../../js/AES";
import axios from "../../js/axios";
export default {
  name: "medicalInstitution",
  components: {},
  data() {
    return {
      jorc: this.$i18n.locale,
      List: [],
      inputData1: "", //搜索框input内容
      tableData: [], //   table内容
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第五个搜索
      searchData6: "", //表格第六个搜索
      searchData7: "", //表格第七个搜索
      searchData8: "", //表格第八个搜索
      dropdownData1: "", //第一个下拉
      currentPage: 1, //页数
      pageSize: 10, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      total: 0,
      sexValue: null,
      sexStatus: null,
      language: "",
      dataItem: "",
      opSex: "All",
      opStatus: "All",
      tableHeight: "", //表格高度
      principalTime: ""
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log(this.language, "语言");
    this.staffNumber();
    this.searchDataStart = this.$route.query.searchData;
    console.log(this.searchDataStart);
    this.select();
    //获取数据字典语言值方法
    this.getLanguage();
    this.selectsex();
    this.getTableHeight();
    this.jpstaffNumber();
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
    //挂载window.onresize事件(动态设置table高度)
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },

  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    //获取下拉框选项
    jpstaffNumber() {
      var that = this;
      that.getLanguage();
      axios
        .get("/modules-parent/common/getDateItem", {
          params: {
            dataItem: this.language === "CN" ? "statusName" : "jpstatusName"
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.sexStatus = aesFecInfo.data;
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    timeJs(date) {
      //获取年份
      var y = date.getFullYear();
      //获取月份  返回0-11
      var m = date.getMonth() + 1;
      // 获取日
      var d = date.getDate();
      //获取星期几  返回0-6   (0=星期天)
      var w = date.getDay();
      //星期几
      var ww = " 星期" + "日一二三四五六".charAt(date.getDay());
      //时
      var h = date.getHours();
      //分
      var minute = date.getMinutes();
      //秒
      var s = date.getSeconds();
      //毫秒
      var sss = date.getMilliseconds();

      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (s < 10) {
        s = "0" + s;
      }
      if (sss < 10) {
        sss = "00" + sss;
      } else if (sss < 100) {
        sss = "0" + sss;
      }
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    dataTimeChange() {
      this.principalTime = this.timeJs(this.searchData4);
      this.fuzzy();
    },
    pickerChangeFn(value) {
      if (value === null) {
        this.principalTime = "";
        this.fuzzy();
      }
    },
    //获取表格高度
    getTableHeight() {
      let tableH = 310; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 200) {
        this.tableHeight = 200;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        that.getLanguage();
        that.selectsex();
        // that.fuzzy();
        this.staffNumber();
        this.jpstaffNumber();
      }
    },
    //获得语言
    getLanguage() {
      if (this.language === "CN") {
        this.dataItem = "sex";
      } else {
        this.dataItem = "jpsex";
      }
      console.log("看我的数据字典数据" + this.dataItem);
    },
    //下拉框选项
    selectsex() {
      console.log("下拉方法");
      console.log(this.dataItem);
      var that = this;
      axios
        .get("/modules-parent/common/getDateItem", {
          params: {
            dataItem: this.dataItem
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.sexValue = aesFecInfo.data;
            console.log(that.sexValue);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
      console.log(that.sexValue);
    },
    //跳转至具体页面
    returns(row, event, column) {
      this.$router.push({
        name: "detailsOfCaseProgressInMedicalInstitutions",
        query: {
          resumeId: row.resumeId,
          applyId: row.applyId,
          jobId: row.jobId,
          jobName: row.jobName
        }
      });
      console.log(row);
    },
    //模糊查询
    fuzzy() {
      var dto = {
        education: this.searchData5,
        japanese: this.searchData7,
        resumeId: this.searchData1,
        sex: this.sex,
        name: this.searchData2,
        statusName: this.searchData8,
        jobName: this.searchData3,
        pageNumber: this.currentPage,
        birth: this.principalTime,
        pageSize: this.pageSize,
        profession: this.searchData6
      };
      medicalFuzzyFindAllApplyPerson(dto)
        .then(res => {
          // console.log("模糊查询");
          // console.log(res);
          // console.log(dto);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log("返回数据--->", aesFecInfo);
            this.tableData = aesFecInfo.data;
          } else {
            this.$message.error("模糊查询失败");
          }
        })
        .catch(res => {});
    },
    //获取数据字典
    staffNumber() {
      var that = this;
      axios
        .get("/modules-parent/common/getDateItem", {
          params: {
            dataItem: this.language === "CN" ? "applyStatus" : "jpapplyStatus"
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.List = aesFecInfo.data;
            console.log(that.List);
          } else {
            console.log(res.data);
            console.log("ccj");
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //获取数据
    select() {
      var pageDTO = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      medicalFindAllApplyPerson(pageDTO)
        .then(res => {
          console.log("查询数据");
          console.log(res);
          console.log(pageDTO);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
            this.total = aesFecInfo.total;
          }else if (res.data.code ===10001) {
       
       // this.$message.error("查询成功");
       window.location.href="#/userFailure";
     } else {
            this.$message.error("登录失败。");
          }
        })
        .catch(res => {});
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "Japaneselevel") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["Japaneselevel"] - b["Japaneselevel"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["Japaneselevel"] - a["Japaneselevel"]
          );
        }
      } else {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["recruitmentDate"] - b["recruitmentDate"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["recruitmentDate"] - a["recruitmentDate"]
          );
        }
      }
    },
    //
    handleCurrentChange(e) {
      this.currentPage = e;
      this.select();
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 10;
      } else if (command === "b") {
        this.pageSize = 15;
      } else if (command === "c") {
        this.pageSize = 20;
      } else if (command === "d") {
        this.pageSize = 25;
      }
      this.select();
    },
    handleCommandStatus(e) {
      console.log(e);
      if (e == null) {
        this.searchData8 = "";
        this.opStatus = "All";
        console.log(e);
      } else {
        this.searchData8 = e.code;
        this.opStatus = e.name;
      }
      this.fuzzy();
    },
    //性别筛选
    handleCommandSex(e) {
      console.log(e);
      if (e == null) {
        this.sex = "";
        this.opSex = "All";
        console.log(e);
      } else {
        this.sex = e.code;
        this.opSex = e.name;
      }
      this.fuzzy();
    },
    // 员工申请
    staffApplicationHandleAdd(row) {
      this.$router.push({
        path: "/advancedCertification",
        query: { rowData: row, role: 0 }
      });
    },
    //管理员申请
    managerApplicationHandleAdd(row) {
      this.$router.push({
        path: "/advancedCertification",
        query: { rowData: row, role: 1 }
      });
    }
  }
};
</script>
<style>
.myBox .el-input__prefix {
  left: -1000px;
}
.myBox .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: auto !important;
}
</style>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
}

.main-box {
  margin-top: 10px;
  width: 100%;
  height: 80%;
  padding: 0 40px 0 40px;
  box-sizing: border-box;
}

.search {
  width: 100%;
  height: 25px;
  display: flex;
}

.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}

.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}

.search /deep/ .el-input__icon {
  line-height: 24px;
}

.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}

.table {
  margin-top: 20px;
  /* height: 600px; */
  width: 98%;
}

.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
}

.operate {
  height: 48px;
}

.table /deep/ .el-dropdown {
  width: 100px;
}

.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}

.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.table /deep/ .el-table__cell {
  position: relative;
}

.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -5px;
  right: 0;
  width: 67px;
}

/* .table /deep/ .element.style {
  width: 95%;
  height: 580px;
} */

.pagination {
  width: 100%;
  height: 50px;
  margin-top: 10px;
}

.pagination-main {
  float: right;
  display: flex;
}

.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}

.rowsPage-css {
  background: peru;
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}

.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}

.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}

.form-button button {
  height: 40px;
  line-height: 40px;
  width: 150px;
  background: #fc630c;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}

.title-css {
  font-family: "lucida sans unicode", "lucida grande", sans-serif;
  /*字体*/
  color: #6b5656;
  /*字体颜色*/
  font-size: 2em;
  /*字体大小*/
  text-align: center;
  /*对齐方式*/
  line-height: 4;
  /*行间距*/
}
</style>



// WEBPACK FOOTER //
// src/pages/medicalViewAllCandidates/index.vue